/**
 * Dynamically load a JS file
 * @param {string} src - Path to JS file
 * @returns {Promise<HTMLScriptElement>}
 */
export function loadJs(src, { async = true, defer = false } = {}) {
    if (src) {
        return new Promise((resolve, reject) => {
            // Prevent duplicate loading
            const existingScripts = document.querySelectorAll(`script[src="${src}"]`);

            if (existingScripts.length > 0) {
                const loadedScript = Array.from(existingScripts).find(
                    script => script.getAttribute('js-loaded') === 'true'
                );

                if (loadedScript) {
                    return resolve('existing');
                }
            }

            const script = document.createElement('script');
            script.src = src;
            script.async = async;
            script.defer = defer;

            script.onload = () => {
                script.setAttribute('js-loaded', 'true'); // Mark as loaded
                resolve(script);
            };

            script.onerror = () => {
                reject(new Error(`Failed to load JS: ${src}`));
            };

            document.head.appendChild(script);
        });
    }
}


/**
 * Dynamically load a CSS file
 * @param {string} href - Path to CSS file
 * @returns {Promise<HTMLLinkElement>}
 */
function loadCss(href) {
    if (href) {
        return new Promise((resolve, reject) => {
            // Prevent duplicate loading
            const existingStyles = document.querySelectorAll(`link[href="${href}"]`);

            if (existingStyles.length > 0) {
                const loadedStyle = Array.from(existingStyles).find(
                    style => style.getAttribute('css-loaded') === 'true'
                );

                if (loadedStyle) {
                    return resolve('existing');
                }
            }

            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;

            link.onload = () => resolve(link);
            link.onerror = () => reject(new Error(`Failed to load CSS: ${href}`));

            document.head.appendChild(link);
        });
    }
}

export function lazyLoadImages(container = document) {
    if (!window.lazySizes || !container) return;

    container
    .querySelectorAll('img:not(.lazyloaded):not([fetchpriority="high"])')
    .forEach(img => {
      window.lazySizes.loader.unveil(img);
    });
}

// Attach to window
window.loadCss = loadCss;
window.loadJs = loadJs;
window.lazyLoadImages = lazyLoadImages;